import keyBy from "lodash-es/keyBy";
import pick from "lodash-es/pick";
import { getStateModels } from "../common/getStateModels";
import { getCgiSchemas } from "../common/schemaUtil";
import { getEntityPrimaryKey } from "../stateCommon/getEntityPrimaryKey";
export class BaseCollection {
  constructor(collectionData, options) {
    this.collectionData = collectionData;
    this.options = options;
  }
  getStateModels() {
    return getStateModels(this.collectionData);
  }
  getEntitySchema() {
    return this.collectionData.entity || null;
  }
  getEntityPrimaryKey() {
    return getEntityPrimaryKey(this.collectionData);
  }
  getCgiSchema(cgiName) {
    if (this.collectionData.type === 'http') {
      var _this$collectionData;
      const cgiInfo = (_this$collectionData = this.collectionData) === null || _this$collectionData === void 0 ? void 0 : _this$collectionData.cgiInfo[cgiName];
      if (!cgiInfo) return {};
      return getCgiSchemas(cgiInfo);
    }
    const tpl = this.template.apiTemplates.find(item => item.name === cgiName);
    return {
      querySchema: tpl === null || tpl === void 0 ? void 0 : tpl.request.query,
      bodySchema: tpl === null || tpl === void 0 ? void 0 : tpl.request.body,
      responseSchema: tpl === null || tpl === void 0 ? void 0 : tpl.response.body
    };
  }
  getUsedRequestParams(cgiName) {
    const {
      collectionData
    } = this;
    const cgiInfo = collectionData === null || collectionData === void 0 ? void 0 : collectionData.cgiInfo[cgiName];
    const mapIds = s => {
      var _s$fields;
      return s === null || s === void 0 || (_s$fields = s.fields) === null || _s$fields === void 0 ? void 0 : _s$fields.map(item => item.id);
    };
    if (collectionData.type === 'db' || !cgiInfo) {
      const tpl = this.template.apiTemplates.find(item => item.name === cgiName);
      return {
        body: mapIds(tpl === null || tpl === void 0 ? void 0 : tpl.request.body) || [],
        query: mapIds(tpl === null || tpl === void 0 ? void 0 : tpl.request.query) || []
      };
    }
    const {
      querySchema,
      bodySchema
    } = this.getCgiSchema(cgiName);
    return {
      body: mapIds(bodySchema) || [],
      query: mapIds(querySchema) || []
    };
  }
  getUsedRequestParamsMap(cgiName) {
    const used = this.getUsedRequestParams(cgiName);
    const {
      querySchema,
      bodySchema
    } = this.getCgiSchema(cgiName);
    const queryMap = keyBy(querySchema === null || querySchema === void 0 ? void 0 : querySchema.fields, 'id');
    const bodyMap = keyBy(bodySchema === null || bodySchema === void 0 ? void 0 : bodySchema.fields, 'id');
    return {
      body: pick(bodyMap, used.body),
      query: pick(queryMap, used.query)
    };
  }
}
//# sourceMappingURL=BaseCollection.js.map
